import { render, staticRenderFns } from "./ServicesToOfferSection.vue?vue&type=template&id=c957de44&scoped=true"
import script from "./ServicesToOfferSection.vue?vue&type=script&lang=js"
export * from "./ServicesToOfferSection.vue?vue&type=script&lang=js"
import style0 from "./ServicesToOfferSection.vue?vue&type=style&index=0&id=c957de44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c957de44",
  null
  
)

export default component.exports